document.addEventListener('DOMContentLoaded', function () {
	const socialLinkChain = document.querySelectorAll('.wp-block-social-links .wp-social-link-chain');

	if (!socialLinkChain) {
		return;
	}

	socialLinkChain.forEach((link) => {
		const anchor = link.querySelector('.wp-block-social-link-anchor');
		const tooltip = link.querySelector('.tooltip--copied'); // Find the tooltip within the current link

		if (!tooltip) {
			return;
		}

		anchor.addEventListener('click', function (e) {
			e.preventDefault();

			if (!navigator.clipboard) {
				return;
			}

			const href = this.getAttribute('href');
			navigator.clipboard.writeText(href).then(() => {
				tooltip.style.display = 'block';

				setTimeout(() => {
					tooltip.style.display = 'none';
				}, 2000);
			});
		});
	});
});
